import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'text!../views/create-message.html';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.serviceRequestNumber = $stateParams.serviceRequestNumber;
        $scope.isReply = $stateParams.reply === 'true';
        $scope.message = $state.current.data.message;
        $state.current.data.message = undefined; // Global var

        let title;
        if (angular.isDefined($scope.message)) {
            title = $scope.message.title.substring(0, 3) === 'RE:' ? $scope.message.title : `RE: ${$scope.message.title}`;
        } else {
            title = '';
        }
        $scope.newMessage = ViewModelService.create({
            'title': title,
            'body': '',
            'type': 'question'
        }, 'cc', 'edge.capabilities.servicerequest.message.dto.ServiceRequestMessageDTO');

        $scope.messageTypes = {
            info: _.find($scope.newMessage.type.aspects.availableValues, {
                code: 'info'
            }),
            question: _.find($scope.newMessage.type.aspects.availableValues, {
                code: 'question'
            })
        };
    };

    ctrl.getReplyText = () => {
        return $scope.isReply ? 'servicerequest.views.create-message.button.Reply Now' : 'servicerequest.views.create-message.button.Reply';
    };

    ctrl.getType = (type) => {
        return _.find($scope.messageTypes, {
            code: type
        }).name;
    };

    ctrl.replyToMessage = (serviceRequestMessageForm) => {
        if ($scope.isReply === false) {
            $scope.isReply = true;
            return;
        }
        serviceRequestMessageForm.submitted = true;
        $scope.newMessage.sendDate = new Date();
        if ($scope.newMessage.aspects.subtreeValid) {
            $scope.submitMessagePromise = ServiceRequestService.createMessage($stateParams.serviceRequestNumber, $scope.newMessage.value).then(
                () => {
                    $scope.goToPreviousState();
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.CreateMessageCtrl.Service Request update failed',
                        'servicerequest.controllers.CreateMessageCtrl.Sorry, we were not able to add a new message to your service request.'
                    );
                }
            );
        }
    };

    ctrl.goToPreviousState = () => {
        $state.transitionTo($stateParams.previousState, {
            serviceRequestNumber: $stateParams.serviceRequestNumber
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService'];
export default fn;
